import { PosBackground } from "../../images";

type Props = {};

const Dashboard = (props: Props) => {
  return (
    <div className="flex justify-center w-full overflow-hidden">
      <img src={PosBackground} alt="" className="w-fit h-[91vh]" />
    </div>
  );
};

export default Dashboard;
